import { http } from './api-client';

/**
 * Records a PDF the browser printed from an Admin page (decision D-21), so it
 * sits in the audit log like every server-side export. Needs reports.export.
 */
export async function recordPdfExport(input: {
  list: string;
  rows: number;
  countryId?: number;
  filters?: Record<string, string>;
}): Promise<void> {
  await http.post('/admin/exports/record', input);
}
